import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import { getUrlForImage } from "../cubeComponent/constants/globalFunctions";
import { CONSTANTS } from "../cubeComponent/constants/globalVariable";
import axiosWrapper from "../services/axiosWrapper";
import type {
  UserDetails,
  GetUserDetailsResponse,
  CheckIfAuthenticatedResponse,
  InitiateSignupEmailVerificationResponse,
} from "@ServerTypes/accounts/accounts.schema";
import { setUserDetails } from "../reducers/userDetailsSlice";
import { setCheckIfAuthenticated } from "../reducers/authentication";
import { clearCsrfToken } from "@Services/axiosShared";

const saveUserDetails = setUserDetails;

export function getUserDetails() {
  return (dispatch: AppDispatch) => {
    axiosWrapper.get<GetUserDetailsResponse>(`${getBackendUrl()}/accounts/getUserDetails`).then(async (response) => {
      // SCHEMA GAP: getUserDetailsResponse is the opaque status envelope and does not declare the
      // one-element `data` array the handler really returns.
      const res = response.data.status
        ? (response.data as typeof response.data & { data?: UserDetails[] }).data?.[0]
        : null;
      if (res) {
        let data = {
          ...res,
          lastName: res.lastName ? res.lastName : "",
          profilePicUrl: res.profilePic ? getUrlForImage(res) : "",
          organisation: {
            ...res.organisation,
            logoUrl: res.organisation?.logo ? getUrlForImage(res.organisation, CONSTANTS.ORGANIZATION) : "",
          },
          // portal: {
          //   ...res.portal,
          //   logoUrl: res?.portal?.logo ? getUrlForImage(res.portal, CONSTANTS.PORTAL) : '',
          // },
          signatureUrl: res.signature
            ? `${getBackendUrl()}/fileSystemServer/getSignDocs/${res.signature}?${Date.now()}`
            : "",
          messageFooterContent: res.messageFooter ?? "",
          status: true,
        };
        // Injected by the desktop shell's preload script; absent in the browser, hence the
        // optional calls. Named at the read rather than declared globally.
        (
          window as Window & { electronAPI?: { setUserDataInDesktop?: (d: unknown) => void } }
        ).electronAPI?.setUserDataInDesktop?.(data);
        dispatch(saveUserDetails(data));
      } else {
        dispatch(saveUserDetails({ status: false }));
      }
    });
  };
}

export async function initiateSignupEmailVerification(email: string) {
  return await axiosWrapper.post<InitiateSignupEmailVerificationResponse>(
    `${getBackendUrl()}/accounts/initiateSignupEmailVerification`,
    {
      email,
    },
  );
}

export function getCheckIfAuthenticated() {
  return (dispatch: AppDispatch) => {
    axiosWrapper
      .get<CheckIfAuthenticatedResponse>(`${getBackendUrl()}/accounts/checkIfAuthenticated`, {
        withCredentials: true,
      })
      .then((response) => {
        clearCsrfToken();
        dispatch(setCheckIfAuthenticated({ data: response.data }));
        return response.data;
      });
  };
}
